import routeNames from "constants/route-names";
import { NavProfile } from "constants/field-values";

export interface NavProfileConfig {
	id: NavProfile;
	// Screen that opens after login and when the logo is clicked.
	homeRoute: string;
	sidebarWidth: number;
	sidebarCollapsedWidth: number;
	sidebarBrand: "app" | "ollie";
}

export const NAV_PROFILES: Record<NavProfile, NavProfileConfig> = {
	[NavProfile.Default]: {
		id: NavProfile.Default,
		homeRoute: routeNames.DASHBOARD,
		sidebarWidth: 265,
		sidebarCollapsedWidth: 94,
		sidebarBrand: "app"
	},
	[NavProfile.Ollie]: {
		id: NavProfile.Ollie,
		homeRoute: routeNames.OLLIE_DASHBOARD,
		sidebarWidth: 260,
		sidebarCollapsedWidth: 80,
		sidebarBrand: "ollie"
	}
};

export const toNavProfile = (value: unknown): NavProfile | null => {
	const matchingProfile = Object.values(NavProfile).find(profileId => profileId === value);
	return matchingProfile ?? null;
};

/**
 * Reads a list of "hostname=profile" pairs separated by commas.
 * Example: "ollie.maestrosync.com=ollie,ollie.highnoteai.com=ollie".
 * Pairs with an unknown profile are ignored.
 */
export const parseNavProfileDomains = (rawDomains?: string): Record<string, NavProfile> => {
	const navProfileByHostname: Record<string, NavProfile> = {};

	(rawDomains ?? "").split(",").forEach(pair => {
		const [hostname, profileName] = pair.split("=").map(part => part.trim());
		const navProfile = toNavProfile(profileName);
		if (hostname && navProfile) {
			navProfileByHostname[hostname.toLowerCase()] = navProfile;
		}
	});

	return navProfileByHostname;
};

const navProfileByHostname = parseNavProfileDomains(process.env.REACT_APP_NAV_PROFILE_DOMAINS);

// Known when the page loads, before the user data arrives.
export const NAV_PROFILE_FROM_DOMAIN = navProfileByHostname[window.location.hostname.toLowerCase()] ?? null;
